export const addresses = {
  wallet: "0xc1e0D3158f6bA2D6Aab5f4565C902922188beE10",
  alphabetProvider: "0xeAaf6D73fb5C63478D09e523a5Fd8b28f9E5Be9a",
};
